<template>
  <div class="harit-account-wrap" ref="root">
    <div class="harit-account" @click="open = !open" role="button" tabindex="0" @keydown.enter="open = !open">
      <span class="harit-avatar">
        <img :src="avatar" alt="" />
      </span>
      <span class="d-none d-md-block">
        <span class="harit-account-name d-block">{{ displayName }}</span>
        <span class="harit-account-role d-block">{{ displayRole }}</span>
      </span>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
        stroke-linecap="round" stroke-linejoin="round" :style="{ transform: open ? 'rotate(180deg)' : null }">
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>

    <div class="harit-account-menu" v-if="open">
      <div class="harit-account-menu-head">
        <div class="fw-semibold">{{ displayName }}</div>
        <div class="small text-muted">{{ user && user.email }}</div>
        <div class="small text-muted">{{ user && user.phone }}</div>
        <span class="harit-chip harit-chip-green mt-2">{{ displayRole }}</span>
      </div>
      <button type="button" class="harit-account-menu-item" @click="goProfile()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
        My Profile
      </button>
      <button type="button" class="harit-account-menu-item is-danger" @click="logout()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <path d="m16 17 5-5-5-5" />
          <path d="M21 12H9" />
        </svg>
        Logout
      </button>
    </div>
  </div>
</template>

<script>
import avatar from '@/assets/images/avatars/user_icon.png'
import axios from 'axios'
import store from '../store'

export default {
  name: 'AppHeaderDropdownAccnt',
  data() {
    return {
      avatar: avatar,
      baseURL: store.state.baseURL,
      open: false,
    }
  },
  computed: {
    // Read through the store rather than a data() snapshot, so editing your
    // own profile updates the masthead without a page reload.
    user() {
      return this.$store.state.user
    },
    displayName() {
      if (!this.user) return ''
      return this.user.name || [this.user.firstname, this.user.lastname].filter(Boolean).join(' ')
    },
    displayRole() {
      return this.user && this.user.role ? this.user.role.replace(/-/g, ' ') : ''
    },
  },
  created() {
    this.isLoggedIn()
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick)
  },
  methods: {
    onDocumentClick(e) {
      if (this.open && this.$refs.root && !this.$refs.root.contains(e.target)) this.open = false
    },
    goProfile() {
      this.open = false
      this.$router.push('/profile')
    },
    logout() {
      this.open = false
      axios({
        url: this.baseURL + 'user/logout',
        method: 'GET',
        headers: { authorization: store.state.token },
      })
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      store.commit('logoutUser')
      this.$router.push({ name: 'Login' })
    },
    isLoggedIn() {
      axios({
        url: this.baseURL + 'user/isLoggedIn',
        method: 'GET',
        headers: { authorization: store.state.token },
      })
        .then((response) => {
          if (!response.data.status) {
            this.logout()
          } else {
            store.commit('loginUser', {
              token: response.data.data.token,
              user: response.data.data,
            })
          }
        })
        .catch((err) => {
          console.log(err)
          this.$notify({
            group: 'notification',
            type: 'error',
            title: 'Error in authentication',
            text: 'Please login again!',
          })
          this.logout()
        })
    },
  },
}
</script>

<style lang="scss">
.harit-account-wrap {
  position: relative;
}

.harit-account-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  z-index: 1050;
  min-width: 250px;
  background: #fff;
  border: 1px solid var(--harit-border);
  border-radius: var(--harit-radius);
  box-shadow: 0 12px 32px rgba(16, 33, 24, 0.16);
  overflow: hidden;

  .harit-account-menu-head {
    padding: 1rem 1.1rem;
    border-bottom: 1px solid var(--harit-border);
    word-break: break-word;
  }

  .harit-account-menu-item {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    width: 100%;
    padding: 0.75rem 1.1rem;
    border: 0;
    background: transparent;
    color: var(--harit-ink);
    font-size: 0.92rem;
    text-align: left;
    cursor: pointer;

    &:hover {
      background: #f4f7f5;
      color: var(--harit-green);
    }

    &.is-danger:hover {
      background: #fdf1f0;
      color: #c0392b;
    }
  }
}
</style>
